import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
  enableProdMode();
}

datadogRum.init({
  applicationId: 'fdfc72ea-2a52-4579-aec1-26ceb9189062',
  clientToken: 'pub83afac07206d8c70610e86f0b8915801',
  site: 'us3.datadoghq.com',
  service: 'gcm.clientscope',
  env: environment.Environment,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackBfcacheViews: true,
  defaultPrivacyLevel: 'mask-user-input',
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  allowedTracingUrls: [(url: string) => url.startsWith("https://clientscope")]
});

datadogRum.startSessionReplayRecording();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));